class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector("dialog");
    this.onBodyClickHandler = this.onBodyClick.bind(this);
  }

  show() {
    this.open();
  }

  onBodyClick(event) {
    if (event.target !== this.dialog) return;
    this.close();
  }

  open() {
    document.documentElement.classList.add("overflow-hidden");
    this.dialog.showModal();
    document.addEventListener("click", this.onBodyClickHandler);
    publish(PUB_SUB_EVENTS.dialogOpen);
  }

  close() {
    this.dialog.close();
    document.documentElement.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    document.removeEventListener("click", this.onBodyClickHandler);
    this.querySelector("predictive-search-component").reset();
    publish(PUB_SUB_EVENTS.dialogClose);
  }
}
customElements.define("search-modal", SearchModal);

class SearchButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    this.button &&
      this.button.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const searchModal = document.querySelector("search-modal");
    if (!searchModal) return;
    searchModal.show();
  }
}
customElements.define("search-button", SearchButton);
